import { render, staticRenderFns } from "./IndexReportListItem.vue?vue&type=template&id=d636ab74&scoped=true"
import script from "./IndexReportListItem.vue?vue&type=script&lang=js"
export * from "./IndexReportListItem.vue?vue&type=script&lang=js"
import style0 from "./IndexReportListItem.vue?vue&type=style&index=0&id=d636ab74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d636ab74",
  null
  
)

export default component.exports